// PWA helpers: add-to-home-screen prompt capture, standalone detection, safe-area readout.
const K = "ali_a2hs";
let deferred = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new CustomEvent("ali-a2hs-ready")); });
  window.addEventListener("appinstalled", () => { deferred = null; try { localStorage.setItem(K, "never"); } catch {} });
}

export const isStandalone = () => (window.matchMedia?.("(display-mode: standalone)").matches) || window.navigator.standalone === true;
export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && window.innerWidth < 1024);
export const isTouch = () => !!window.matchMedia?.("(pointer: coarse)").matches;
export const hasNativeInstall = () => !!deferred;

export async function promptInstall() {
  if (!deferred) return "unavailable";
  const p = deferred; deferred = null;
  p.prompt();
  const r = await p.userChoice.catch(() => ({ outcome: "dismissed" }));
  return r.outcome;
}

export function a2hsDismissed() {
  try { const v = localStorage.getItem(K); if (!v) return false; if (v === "never") return true; return Date.now() < Number(v); } catch { return false; }
}
export const dismissA2hs = (never) => { try { localStorage.setItem(K, never ? "never" : String(Date.now() + 7 * 864e5)); } catch {} };
export function shouldAutoShowA2hs() {
  try { if (localStorage.getItem("ali_a2hs_force") === "1") return true; } catch {}
  return isMobile() && !isStandalone() && !a2hsDismissed();
}
export const openInstallPrompt = () => window.dispatchEvent(new CustomEvent("ali-a2hs-open"));

export function safeBottom() {
  const v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
  return Number.isFinite(v) ? v : 0;
}
